export default __webpack_public_path__ + "static/damixa-commercial-bg--mobile@1x-ccbe667b1a26ba7de003a229b93b3d2c.jpg";